import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FormBaseComponent } from '../form-base/form-base.component';
import { provideParentFormGroup } from '../forms.utils';

@Component({
  selector: 'app-form-button-toggle',
  imports: [CommonModule, TranslateModule, MatButtonToggleModule, ReactiveFormsModule, MatInputModule],
  templateUrl: './form-button-toggle.component.html',
  styleUrl: './form-button-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormButtonToggleComponent extends FormBaseComponent {
  @Input() value1: any;
  @Input() label1T: string;

  @Input() value2: any;
  @Input() label2T: string;
}
